import { BASE_URL } from '../../../../config/environmentConfig';
import axios from 'axios';
import { merchantActionTypes } from '../action-types';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import * as Sentry from '@sentry/react';
import * as React from 'react';
import { IAction } from '../merchant-interfaces';
import { GET, PUT } from '../../store-helper';

export const fetchSftpConfig = async (dispatch: React.Dispatch<IAction>, mid?: string): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.START_SFTP_CONFIG_LOADING });
		let url = `${BASE_URL.MERCHANTS}/Config/sftp`;
		if (mid) {
			url += `?mid=${mid}`;
		}

		const data = await GET({ pathname: url });

		dispatch({ type: merchantActionTypes.FETCH_SFTP_CONFIG, payload: data ?? null });
	} catch (e) {
		Sentry.setTag('fetch-sftp-list-mid', mid);
		sendSentryMessage({ name: `GET Fetch sftp list error`, context: e });
		dispatch({ type: merchantActionTypes.FETCH_SFTP_CONFIG, payload: {}});
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
		console.log('e', e);
	}
};

export const setSftpConfig = async (mid: string): Promise<void> => {
	await axios.post(`${BASE_URL.MERCHANTS}/Config/sftp?mid=${mid}`, {});
};

export const updateSftpKeys= async (mid: string, publicKey: string, privateKey: string, publicSshKeyId: string): Promise<void> => {
	try {
		const url = `${BASE_URL.MERCHANTS}/Config/sftp-keys`;
		const data = {
			merchantId: mid,
			PublicSshKey: null,
			PrivateSshKey: null,
			PublicSshKeyId: publicSshKeyId,
		};
		if (privateKey.length > 3) {
			data.PrivateSshKey = privateKey;
		}
		if (publicKey.length > 3) {
			data.PublicSshKey = publicKey;
		}
		await PUT({ pathname: url, body: data });

	} catch (e) {
		console.log('e', e);
	}
};
